exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-kisan-hub-dashboard .mat-card-title {\n  color: #c1c1c1;\n  font-weight: lighter; }\n", ""]);

// exports
